import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Alert,
    Card,
    CardBody,
    CardHeader,
    Container
} from "reactstrap";

import GroupService from "../Services/GroupService";
import { CoordinatorDto, CreateGroupDto, GroupFormData } from "../types/Group";
import GroupForm from "./GroupForm";

const CreateGroupPage = () => {

    const navigate = useNavigate();
    // eslint-disable-next-line
    const [error, setError] = useState("");
    const [coordinators, setCoordinators] = useState<CoordinatorDto[]>([]);
    const initialValues: GroupFormData = {
    groupName: "",
    type: "",
    category: "",
    shortDescription: "",
    longDescription: "",
    syllabus: "",

    amount: 0,

    region: "",
    state: null,
    district: null,
    language: "",

    isPaymentRequired: false,
    groupPayment: null,

    notificationBanner: "",

    coordinatorIds: [],

    isActive: true
};
    useEffect(() => {

        GroupService.getCoordinators()
            .then(setCoordinators);

    }, []);
    const handleSubmit = async (
        data: GroupFormData
    ) => {

      const dto: CreateGroupDto = {
    groupName: data.groupName,
    type: data.type,
    category: data.category,
    shortDescription: data.shortDescription,
    longDescription: data.longDescription,
    syllabus: data.syllabus,

    amount: data.amount,

    isPaymentRequired: data.isPaymentRequired,
    groupPayment: data.groupPayment,   // <-- ADD THIS

    notificationBanner: data.notificationBanner,

    coordinatorIds: data.coordinatorIds,

    region: data.region,
    state: data.state,                 // <-- ADD THIS
    district: data.district,           // <-- ADD THIS
    language: data.language
};
        console.log(dto);

        await GroupService.create(dto);

        navigate("/admin/groups");

    };

    return (

      <Container
  className="py-5"
  style={{
    maxWidth: "850px",
  }}
>
  <Card
    style={{
      border: "none",
      borderRadius: "20px",
      overflow: "hidden",
      boxShadow: "0 15px 35px rgba(0,0,0,0.12)",
    }}
  >
    <CardHeader
      style={{
        background: "linear-gradient(135deg,#2563eb,#4f46e5)",
        color: "#fff",
        padding: "25px",
        border: "none",
      }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <h3 className="mb-1 fw-bold">Create New Group</h3>
          <small style={{ opacity: 0.9 }}>
            Create a new group and assign coordinators.
          </small>
        </div>

        <div
          style={{
            width: "55px",
            height: "55px",
            borderRadius: "50%",
            background: "rgba(255,255,255,0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "24px",
          }}
        >
          👥
        </div>
      </div>
    </CardHeader>

    <CardBody
      style={{
        padding: "35px",
        background: "#fafbff",
      }}
    >
      {error && (
        <Alert
          color="danger"
          style={{
            borderRadius: "12px",
          }}
        >
          {error}
        </Alert>
      )}

      <GroupForm
        initialValues={initialValues}
        coordinators={coordinators}
        onSubmit={handleSubmit}
      />
    </CardBody>
  </Card>
</Container>

    );

};

export default CreateGroupPage;